import { render, staticRenderFns } from "./sky-sortSelect.vue?vue&type=template&id=33ec86d8&scoped=true"
import script from "./sky-sortSelect.vue?vue&type=script&lang=js"
export * from "./sky-sortSelect.vue?vue&type=script&lang=js"
import style0 from "./sky-sortSelect.vue?vue&type=style&index=0&id=33ec86d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec86d8",
  null
  
)

export default component.exports